/**
 * The scrollbar for panels that scroll — settings, the modes panel, the
 * drawer, the sidebar, the sheets, the event log.
 *
 * Spread it into the rule that owns the `overflow`, not a parent:
 *
 *   modal: { overflowY: 'auto', ...scrollbar }
 *
 * Two halves, both needed. `scrollbarWidth`/`scrollbarColor` are the standard
 * properties Firefox and Chrome 121+ read, and are the only thing those
 * browsers honour — but they cannot express a rounded, inset thumb, so the
 * `::-webkit-scrollbar` rules carry the shape everywhere else. Neither half
 * replaces the other.
 *
 * The gutter is left empty on purpose: a scrolling panel here is already a
 * recessed plate, and painting a track over it would put a second groove
 * inside the first. The thumb is clipped to its padding box so it floats as
 * a slim bar with room around it rather than filling the gutter edge to edge.
 */
const THUMB = '#5c3a1e';
const THUMB_HOVER = '#6b4622';

const scrollbar = {
  scrollbarWidth: 'thin',
  scrollbarColor: `${THUMB} transparent`,
  '&::-webkit-scrollbar': {
    width: '10px',
    height: '10px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: THUMB,
    borderRadius: '999px',
    border: '2px solid transparent',
    backgroundClip: 'padding-box',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: THUMB_HOVER,
    // Without re-stating the clip the thumb snaps to full width on hover.
    backgroundClip: 'padding-box',
  },
  '&::-webkit-scrollbar-corner': {
    background: 'transparent',
  },
};

export default scrollbar;
